import { useEffect, useState } from "react";
import { Skeleton } from "antd";

const steps = [
    "Открываем вашу книгу… 📖",
    "Листаем оглавление… 🔎",
    "Извлекаем главы… 📂",
    "Размечаем текст… ✍️",
    "Формируем страницы под ваше устройство… 📱",
    "Подбираем оптимальный размер шрифта… 🔤",
    "Считаем символы… 🔢",
    "Подгоняем интерлиньяж… 📏",
    "Оптимизируем отображение… ⚙️",
    "Добавляем немного книжной магии… ✨",
    "Прогреваем типографский станок… 🏭",
    "Собираем первую страницу… 🧩",
    "Прорисовываем абзацы… 🎨",
    "Почти готово… ⏳",
    "Последние штрихи… 🪶",
    "Уведение обложки… 🖼️",
    "Готовим уютную атмосферу для чтения… ☕",
    "Вот-вот откроется… 🚀"
];

export default function LoadingBookSkeleton() {
    const [stepIndex, setStepIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setStepIndex((prev) => (prev + 1) % steps.length);
        }, 1200); // меняем сообщение каждые 1.2 секунды

        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{ padding: "16px", animation: "fadeIn 0.5s" }}>
            <Skeleton
                active
                title={false}
                paragraph={{ rows: 6 }}
                style={{ marginBottom: 16 }}
            />

            <div
                style={{
                    textAlign: "center",
                    fontSize: "16px",
                    color: "#888",
                    fontStyle: "italic",
                    transition: "opacity 0.5s"
                }}
            >
                {steps[stepIndex]}
            </div>
        </div>
    );
}
